import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const radioLabelVariants = cva('', {
  variants: {
    size: {
      medium: styles.radioLabelMedium,
      regular: styles.radioLabelRegular,
    },
  },
  defaultVariants: {
    size: 'regular',
  },
});

export const radioDescriptionVariants = cva('', {
  variants: {
    size: {
      medium: styles.radioDescriptionMedium,
      regular: styles.radioDescriptionRegular,
    },
  },
  defaultVariants: {
    size: 'regular',
  },
});
